import React from 'react';
import NotificatorAdmin from './NotificatorAdmin';
import { currentUser } from '../../util/currentUser';
import { Link } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';

const BarTopAdmin = () => {
    
    //deconnecter l'utilisateur 
    const deconnecter = ()=>{
        const auth = getAuth();
        signOut(auth).then(() => {
        // Sign-out successful.
            alert('deconnecté')
        }).catch((error) => {
        // An error happened.
            alert(error)
        });
    }

    return (
        <div className='bg-light shadow mb-3'>
            <div className='row'>
                <div className='pe-5'>
                
                    
                    <div className="nav-item dropdown pt-3">
                        <NotificatorAdmin></NotificatorAdmin> 
                        <p className="nav-lin dropdown-toggle navbar-profile-name d-inline "  href="#" id="navbarScrollingDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={currentUser.imgSrc} alt="" className=' rounded-circle border border-primary mx-3' style={{width:"40px", height:"40px"}}/>
                            {currentUser.userName}
                        </p>
                        <ul className="dropdown-menu"  aria-labelledby="navbarScrollingDropdown">
                                <p className="mx-3"><Link className=" btn btn-danger text-white " to="/Connexion" onClick={deconnecter}>Deconnexion</Link></p>                    
                        </ul>
                    </div>
                </div>  
            </div>
        </div>
    );
};

export default BarTopAdmin;